import React, { useState, useEffect } from "react";
import axios from "axios";
import { Grid } from "@mui/material";
import DialogWrapper from "./DialogWrapper";
import StyledTextField from "./elements/StyledTextField";
import { useMsal } from "@azure/msal-react";
import { getDashboards, handleEmbedDashboard } from "../services/api/dashboard.api";

export default function AddDashboardDialog({ open, onClose, onSave }) {
  const [name, setName] = useState("");
  const [embeddedId, setEmbeddedId] = useState("");
  const [errors, setErrors] = useState({ name: false, embeddedId: false });
  const [loading, setLoading] = useState(false);
  const { instance } = useMsal();

  const currentAccount = instance.getActiveAccount();

  useEffect(() => {
    if (open) {
      setName("");
      setEmbeddedId("");
      setErrors({ name: "", embeddedId: "" });
    }
  }, [open]);

  const handleSave =  () => {
    onSave({
      name,
      embed_id: embeddedId,
      added_by: currentAccount.homeAccountId, 
    });
    onClose();
  };

  const handleValidateEmbedDashboard = async () => {
    try {
      setLoading(true);
      if (!name || !embeddedId) {
        setErrors({
          name: !name ? "Required field" : "",
          embeddedId: !embeddedId ? "Required field" : "",
        });
        return;
      }

      const response = await handleEmbedDashboard({
        resources: [
          {
            type: "dashboard",
            id: embeddedId,
          },
        ],
      });

      if (response?.status !== 200) {
        return;
      }
  
      const dashboards = await getDashboards();
  
      const dashboardData = dashboards?.data || [];
  
      // Validate if 'name' and 'embedId' exist in dashboards response
      const isDuplicateEmbedId = dashboardData.some(
        (dashboard) => dashboard.embed_id === embeddedId
      );
  
      const isDuplicateName = dashboardData.some(
        (dashboard) => dashboard.name.toLowerCase() === name.toLowerCase()
      );
  
      if (isDuplicateEmbedId) {
        setErrors({
          ...errors,
          embeddedId: "Embed ID already exists",
        });
        return;
      }
  
      if (isDuplicateName) {
        setErrors({
          ...errors,
          name: "Name already exists",
        });
        return;
      }
      handleSave();
    } catch (error) {
      setErrors({
        ...errors,
        embeddedId: "Invalid Embedded ID",
      });
      console.error("Error validating dashboard:", error.message);
    } finally {
      setLoading(false);
    }
  };
  

  return (
    <DialogWrapper
      open={open}
      cancelLabel="Cancel"
      actionLabel={loading ? "Saving..." : "Save"}
      title="Add New Dashboard"
      cancelAction={onClose}
      acceptButton={handleValidateEmbedDashboard}
      disabled={loading}
    >
      <Grid container spacing={3} sx={{ mt: 1 }}>
        <Grid item xs={6} style={{ paddingLeft: "16px", paddingTop: "16px" }}>
          <StyledTextField
            label="Name *"
            placeholder="Add Name"
            required
            value={name}
            onChange={(e) => {
              setName(e.target.value);
              setErrors((prev) => ({ ...prev, name: '' }));
            }}
            helperText={errors.name ? errors.name : ""}
          />
        </Grid>

        <Grid item xs={6} style={{ paddingLeft: "32px", paddingTop: "16px" }}>
          <StyledTextField
            label="Embedded ID *"
            placeholder="Enter Embedded ID"
            required
            value={embeddedId}
            onChange={(e) => {
              setEmbeddedId(e.target.value);
              setErrors((prev) => ({ ...prev, embeddedId: '' }));
            }}
            helperText={errors?.embeddedId ? errors?.embeddedId : ""}
          />
        </Grid>
      </Grid>
    </DialogWrapper>
  );
}
